<template>
  <div class="on-animation">
    <div class="skip-btn" @click="skip()" v-if="videoShow">跳过</div>
    <div class="home-video">
      <video src="https://img.cagibrand.com/yszsg/images/brand.mp4" muted autoplay class="video" :class="{'video-hid':!videoHid}" @ended="ended" v-if="videoShow">
        您的浏览器不支持 video 标签。
      </video>
      <div class="btn-box">
        <img src="../../static/img/logo.png" class="logo">
        <div>
          <img src="../../static/img/home/ch-btn.png" alt="" class="btn-img" @click="selL('1422454440404713472')">
          <img src="../../static/img/home/en-btn.png" alt="" class="btn-img" @click="selL('1422454502115508224')">
        </div>
      </div>
      <!-- <audio preload="auto" loop id="audio" muted src="https://img.mzszxc.com/mzsz/img/website/brand.mp3"></audio> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoHid: true, // video动画
      videoShow: true
    }
  },
  created() {
    if (sessionStorage.getItem('played')) {
      this.$router.replace({
        path: '/home'
      })
    }
  },
  mounted() {
    // 自动播放音乐效果，解决微信自动播放问题
    // document.addEventListener('touchstart', this.audioAutoPlay, false)
    // document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay, false)
    // let oAudio = document.querySelector("#audio")
    // oAudio.play()
    // oAudio.onended = function () {//播放完毕，重新循环播放
    //   oAudio.load()
    //   oAudio.play()
    // }
  },
  methods: {
    audioAutoPlay() {
      let audio = document.getElementById('audio');
      audio.play();
      document.removeEventListener('touchstart', this.audioAutoPlay);
    },
    // 视频播放结束
    ended() {
      this.videoHid = false
      sessionStorage.setItem('played', true)
      setTimeout(() => {
        this.videoShow = false
      }, 1000)
    },
    skip() {
      this.videoShow = false
      sessionStorage.setItem('played', true)
    },
    // 选择语言
    selL(siteId) {
      localStorage.setItem('siteId', siteId)
      this.$router.replace({
        path: '/home'
      })
    }
  }
}
</script>

<style lang="scss">
.on-animation {
  min-height: 100%;
  position: relative;
  .skip-btn {
    position: absolute;
    width: 80px;
    height: 40px;
    right: 20px;
    top: 10px;
    color: #fff;
    border: 1px solid #fff;
    z-index: 9;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-size: 14px;
    line-height: 14px;
  }
  .home-video {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    // display: none;
    .video {
      position: absolute;
      // width: calc(100vh / 0.562);
      width: 100%;
      height: 100%;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: #000;
    }
    .video-hid {
      animation: videoShow 0.8s ease-in forwards;
    }
    .btn-box {
      background: url("../../static/img/home/video-bg.jpg") no-repeat center;
      background-size: 100% 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .logo {
        width: 404px;
      }
      .btn-img {
        width: 246px;
        height: 60px;
        margin: 30px 25px 0;
        cursor: pointer;
      }
    }
  }
}
</style>